// Shared screen-reader labels for modals and carousels. Feature-specific labels
// live in their feature's module.
export const a11yContent = {
  closeAriaLabel: 'Close',

  // Carousels (role descriptions are announced in place of the generic role)
  carouselRoleDescription: 'carousel',
  slideRoleDescription: 'slide',
  previousImageAriaLabel: 'Previous image',
  nextImageAriaLabel: 'Next image',
  imageNavigationAriaLabel: 'Image navigation',
  imagePositionAriaLabelTemplate: 'Image ##Index## of ##Total##',
  photoPositionAriaLabelTemplate: 'Photo ##Index## of ##Total##',
  goToImageAriaLabelTemplate: 'Go to image ##Index##'
}
